<template>
  <SkeletonLoader>
    <div class="team-insights-skeleton">
      <!-- Header -->
      <div class="sk-header">
        <div class="sk-line sk-line--title" style="width: 200px"></div>
      </div>

      <!-- Tab Bar -->
      <div class="sk-tab-bar">
        <div v-for="tab in tabs" :key="tab.id" class="sk-rect" :style="{ width: tab.width, height: '32px' }"></div>
      </div>

      <!-- Content Area: Two Columns -->
      <div class="sk-content">
        <!-- Left Column: Summary Card -->
        <div class="sk-content-left">
          <div class="sk-summary-card">
            <div class="sk-line sk-line--title" style="width: 140px"></div>
            <div v-for="stat in summaryStats" :key="stat.id" class="sk-row sk-stat-row">
              <div class="sk-line" :style="{ width: stat.labelWidth }"></div>
              <div class="sk-line sk-line--lg" :style="{ width: stat.valueWidth }"></div>
            </div>
            <div class="sk-rect sk-chart-placeholder" style="width: 100%; height: 150px"></div>
          </div>
        </div>

        <!-- Right Column: Team Member Cards -->
        <div class="sk-content-right">
          <div v-for="member in teamMembers" :key="member.id" class="sk-member-card">
            <div class="sk-row sk-member-row">
              <div class="sk-circle sk-circle--lg"></div>
              <div class="sk-col">
                <div class="sk-line" :style="{ width: member.nameWidth }"></div>
                <div class="sk-line sk-line--sm" :style="{ width: member.statWidth }"></div>
              </div>
            </div>
            <div class="sk-rect sk-progress-bar" :style="{ width: member.progressWidth }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'TeamInsightsSkeleton',
  components: { SkeletonLoader },
  data () {
    return {
      tabs: [
        { id: 1, width: '90px' },
        { id: 2, width: '110px' },
        { id: 3, width: '80px' },
        { id: 4, width: '100px' }
      ],
      summaryStats: [
        { id: 1, labelWidth: '100px', valueWidth: '60px' },
        { id: 2, labelWidth: '120px', valueWidth: '50px' },
        { id: 3, labelWidth: '90px', valueWidth: '70px' }
      ],
      teamMembers: [
        { id: 1, nameWidth: '130px', statWidth: '90px', progressWidth: '80%' },
        { id: 2, nameWidth: '110px', statWidth: '75px', progressWidth: '60%' },
        { id: 3, nameWidth: '145px', statWidth: '100px', progressWidth: '45%' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.team-insights-skeleton {
  padding: 20px;
}

/* Header */
.sk-header {
  margin-bottom: 20px;
}

/* Tab Bar */
.sk-tab-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 12px;
}

/* Content Two-Column Layout */
.sk-content {
  display: flex;
  gap: 24px;
}

.sk-content-left {
  flex: 0 0 40%;
  min-width: 0;
}

.sk-content-right {
  flex: 0 0 calc(60% - 24px);
  min-width: 0;
}

/* Summary Card */
.sk-summary-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
}

.sk-stat-row {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 8px 0;

  .sk-line {
    margin-bottom: 0;
  }
}

.sk-chart-placeholder {
  margin-top: 16px;
}

/* Team Member Cards */
.sk-member-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

.sk-member-row {
  padding: 0;
  margin-bottom: 12px;

  .sk-line {
    margin-bottom: 4px;
  }
}

.sk-progress-bar {
  height: 8px;
  border-radius: 4px;
}

/* Responsive: Mobile */
@media (max-width: 767px) {
  .sk-content {
    flex-direction: column;
  }

  .sk-content-left,
  .sk-content-right {
    flex: 1 1 100%;
  }

  .sk-tab-bar {
    flex-wrap: wrap;
  }
}
</style>
